var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5461 20H6.36409C6.95388 19.2133 7.2735 18.2562 7.2735 17.2726V14.5453H17.2735C17.5147 14.5453 17.7457 14.6416 17.9161 14.8121C18.0866 14.9825 18.1829 15.2135 18.1829 15.4547V16.3641C18.1829 17.3281 17.7994 18.2536 17.1175 18.9354C16.4357 19.6172 15.5109 20 14.5461 20ZM14.5461 0.908536V12.7273H6.36409C5.86209 12.7273 5.45468 13.1347 5.45468 13.6367V17.2735V17.2727C5.45468 18.7795 4.23419 20 2.72734 20C1.22134 20 -1.33171e-05 18.7795 -1.33171e-05 17.2727V0.908556C-1.33171e-05 0.40655 0.407387 0 0.909394 0H13.6367C13.8779 0 14.1098 0.0954572 14.2802 0.265927C14.4507 0.436398 14.5461 0.667329 14.5461 0.908536Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxation);
export default __webpack_public_path__ + "static/media/taxation.553c0a3d00c8537f3ad6b90124af18fa.svg";
export { ForwardRef as ReactComponent };